export const exchangedTypesValues = {
  variant: 'variant',
  otherProduct: 'other_product',
  multipleProducts: 'multiple_products',
}

export const exchangedTypesOptions = [
  {
    value: exchangedTypesValues.variant,
    label: 'Cambio de variante',
  },
  {
    value: exchangedTypesValues.otherProduct,
    label: 'Cambio de producto',
  },
  {
    value: exchangedTypesValues.multipleProducts,
    label: 'Cambio por múltiples productos',
  },
]
